import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
  CORE_I18N_FOLDER,
  CORE_PAGE_MODULE,
  CorePageModule,
  CorePageModuleIDs
} from '@bepatient/core';
import { IonicModule } from '@ionic/angular';

const pageModule: CorePageModule = {
  ID: CorePageModuleIDs.MY_FORMS_LIST,
  i18nLabel: 'MODULES.MY_FORMS_LIST',
  icon: 'list',
  leftMenuAvailableForPages: [0, 1, 2],
  routes: [
    {
      path: 'my-forms-list',
      loadChildren: () =>
        import('./pages/my-forms-list/my-forms-list.module').then(
          m => m.MyFormsListPageModule
        )
    }
  ]
};

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild(pageModule.routes)
  ],
  providers: [
    { provide: CORE_PAGE_MODULE, useValue: pageModule, multi: true },
    {
      provide: CORE_I18N_FOLDER,
      useValue: './my-forms-list/i18n/',
      multi: true
    }
  ]
})
export class MyFormsListModule {}
